export default __webpack_public_path__ + "images/assets/35bbcd3bb3b642a5cd8cdc848849b840.svg";